var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "invoice-grid invoice-row invoice-row--skeleton" },
      [
        _c("div", { staticClass: "skeleton-cell" }, [
          _c("div", { staticClass: "skeleton skeleton-unit" }),
          _c("div", { staticClass: "skeleton skeleton-history" })
        ]),
        _c("div", { staticClass: "skeleton-cell" }, [
          _c("div", { staticClass: "skeleton skeleton-period" })
        ]),
        _c("div", { staticClass: "skeleton-cell" }, [
          _c("div", { staticClass: "skeleton skeleton-invoice" })
        ]),
        _c("div", { staticClass: "skeleton-cell" }, [
          _c("div", { staticClass: "skeleton skeleton-date" })
        ]),
        _c("div", { staticClass: "skeleton-cell" }, [
          _c("div", { staticClass: "skeleton skeleton-status" })
        ]),
        _c("div", { staticClass: "skeleton-cell text-right" }, [
          _c("div", { staticClass: "skeleton skeleton-amount skeleton-right" })
        ]),
        _c("div", { staticClass: "skeleton-cell text-right" }, [
          _c("div", { staticClass: "skeleton skeleton-amount skeleton-right" })
        ]),
        _c("div", { staticClass: "skeleton-cell" }, [
          _c("div", { staticClass: "skeleton skeleton-branch" })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }